import React from 'react'
import PropTypes from 'prop-types'
import providesApplicationByEmbedType from 'components/Integrations/dataSync/providesApplicationByEmbedType'
import IntegrationSuggestion from 'components/Editors/plugins/integration-suggestion/components/index'
import { Consumer as SharedEventBusContextConsumer } from 'contexts/sharedEventBus'

export default function makeEmbedPlaceholderPluginDecorator(
  integrationSuggestionProps
) {
  return function(Component) {
    class EmbedPlaceholderPluginDecorator extends React.Component {
      static propTypes = {
        embedType: PropTypes.string.isRequired,
        application: PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          isInstalled: PropTypes.bool.isRequired,
          integration: PropTypes.shape({
            hasAuthenticationForUser: PropTypes.bool.isRequired,
          }),
        }),
        applicationLoaded: PropTypes.bool.isRequired,
      }

      state = {
        hideIntegrationSuggestion: false,
      }

      makeOnConnectAppHandler = ({
        callback = () => {},
        eventBusStore,
        application,
      }) => {
        return (...args) => {
          callback(...args)

          // Open ShareToModal for user authentication.
          // Todo: Split those two behaviors and call only the user auth one.
          eventBusStore.updateItem('event', {
            type: 'showShareToModal',
            metadata: {
              integration: {
                ...application.integration,
                application: {
                  clientId: application.id,
                  ...application,
                },
              },
              selectedText: '',
              performAuthenticationOnly: true,
            },
          })
        }
      }

      makeHandleHideBlockAfterAction = callback => {
        return (...args) => {
          this.setState({ hideIntegrationSuggestion: true }, () => {
            callback(...args)
          })
        }
      }

      render() {
        const localIntegrationSuggestionProps = Object.entries(
          integrationSuggestionProps
        ).reduce((dictionary, [key, callback]) => {
          dictionary[key] = this.makeHandleHideBlockAfterAction(callback)
          return dictionary
        }, {})

        const { hideIntegrationSuggestion } = this.state
        const { applicationLoaded, application } = this.props
        const applicationIsLoadedAndFound = applicationLoaded && application
        const applicationIsInstalled =
          applicationIsLoadedAndFound && application.integration
        const applicationNeedsUserAuthentication =
          applicationIsInstalled &&
          !application.integration.hasAuthenticationForUser
        const integrationSuggestionShouldBeDisplayed =
          !hideIntegrationSuggestion &&
          applicationIsLoadedAndFound &&
          (!applicationIsInstalled || applicationNeedsUserAuthentication)

        const extractorsSelectorFilter = !applicationIsInstalled
          ? // The user has decided to hide the incentive
            // let's bypass the integrationExtractor
            extractor => extractor.name === 'iframelyExtractor'
          : () => true

        return (
          <React.Fragment>
            <Component
              {...this.props}
              extractorsSelectorFilter={extractorsSelectorFilter}
            />
            {integrationSuggestionShouldBeDisplayed && (
              <SharedEventBusContextConsumer>
                {eventBusStore => (
                  <IntegrationSuggestion
                    {...localIntegrationSuggestionProps}
                    onConnectApp={this.makeOnConnectAppHandler({
                      callback: localIntegrationSuggestionProps.onConnectApp,
                      eventBusStore,
                      application,
                    })}
                    clientId={application.id}
                    for={
                      application.isInstalled ? 'appAssociation' : 'enableApp'
                    }
                    name={application.name.toLowerCase()}
                    iconURL={application.photoURL}
                  />
                )}
              </SharedEventBusContextConsumer>
            )}
            {/* // todo Have a loading status? */}
            {/* {applicationLoaded === false && <span>Loading...</span>} */}
          </React.Fragment>
        )
      }
    }

    return providesApplicationByEmbedType()(EmbedPlaceholderPluginDecorator)
  }
}
